<template>
  <div>
    <section class="te-teams">
      <div class="te-teams__colstatic">
        <div class="te-teams__colstatic__empty"></div>
        <template v-for="(category, index) in infoInactiveTime">
          <div :key="index" class="te-teams__colstatic__category-name ">{{ category.name }}</div>
        </template>
      </div>
      <div class="te-teams__colscroll">
        <div class="te-teams__colscroll__wrapper">
          <div class="te-teams__colscroll__wrapper__col">
            <div class="te-teams__colscroll__wrapper__col__row-header">
              <div class="te-teams__colscroll__wrapper__col__row-header__item">
                Eventos Totales
                <div v-if="type != 1" class="te-teams__colscroll__wrapper__col__row-header__item__text">
                  (en lo que va del torneo)
                </div>
              </div>
            </div>
            <div class="te-teams__colscroll__wrapper__col__row-subheader">
              <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team">
                <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column">
                  <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column__item">
                    <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.home_team + '.png'" />
                  </div>
                </div>
                <template v-for="(totalevents, index) in infoInactiveTime">
                  <div :key="index" class="te-teams__colscroll__wrapper__col__row-subheader__col-team__row-value ">
                    {{ totalevents.home_team.total_events }}
                  </div>
                </template>
              </div>
              <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team">
                <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column">
                  <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column__item">
                    <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.visiting_team + '.png'" />
                  </div>
                </div>
                <template v-for="(totalevents, index) in infoInactiveTime">
                  <div :key="index" class="te-teams__colscroll__wrapper__col__row-subheader__col-team__row-value">
                    {{ totalevents.visiting_team.total_events }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="te-teams__colscroll__wrapper__col">
            <div class="te-teams__colscroll__wrapper__col__row-header">
              <div class="te-teams__colscroll__wrapper__col__row-header__item">
                Tiempo promedio <br />perdido por evento
                <div v-if="type != 1" class="te-teams__colscroll__wrapper__col__row-header__item__text">
                  (en lo que va del torneo)
                </div>
              </div>
            </div>
            <div class="te-teams__colscroll__wrapper__col__row-subheader">
              <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team">
                <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column">
                  <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column__item">
                    <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.home_team + '.png'" />
                  </div>
                </div>
                <template v-for="(totalevents, index) in infoInactiveTime">
                  <div :key="index" class="te-teams__colscroll__wrapper__col__row-subheader__col-team__row-value">
                    <template v-if="totalevents.home_team.below_average == 1">
                      <div><img src="https://golstatsimages.blob.core.windows.net/todoelfut/time_average@2x2.png" /></div>
                    </template>
                    <template v-else>
                      <template v-if="totalevents.home_team.below_average == 2">
                        <div><img src="https://golstatsimages.blob.core.windows.net/todoelfut/time_average@2x.png" /></div>
                      </template>
                    </template>

                    {{ totalevents.home_team.time_lost_per_event_average }}
                  </div>
                </template>
              </div>
              <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team">
                <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column">
                  <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column__item">
                    <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.visiting_team + '.png'" />
                  </div>
                </div>
                <template v-for="(totalevents, index) in infoInactiveTime">
                  <div :key="index" class="te-teams__colscroll__wrapper__col__row-subheader__col-team__row-value">
                    <template v-if="totalevents.visiting_team.below_average == 1">
                      <div><img src="https://golstatsimages.blob.core.windows.net/todoelfut/time_average@2x2.png" /></div>
                    </template>
                    <template v-else>
                      <template v-if="totalevents.visiting_team.below_average == 2">
                        <div><img src="https://golstatsimages.blob.core.windows.net/todoelfut/time_average@2x.png" /></div>
                      </template>
                    </template>
                    {{ totalevents.visiting_team.time_lost_per_event_average }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="te-teams__colscroll__wrapper__col">
            <div class="te-teams__colscroll__wrapper__col__row-header">
              <div class="te-teams__colscroll__wrapper__col__row-header__item">
                Tiempo total <br />perdido por evento
                <div v-if="type != 1" class="te-teams__colscroll__wrapper__col__row-header__item__text">
                  (en lo que va del torneo)
                </div>
              </div>
            </div>
            <div class="te-teams__colscroll__wrapper__col__row-subheader">
              <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team">
                <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column">
                  <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column__item">
                    <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.home_team + '.png'" />
                  </div>
                </div>
                <template v-for="(totalevents, index) in infoInactiveTime">
                  <div :key="index" class="te-teams__colscroll__wrapper__col__row-subheader__col-team__row-value">
                    {{ totalevents.home_team.time_lost_per_event_total }}
                  </div>
                </template>
              </div>
              <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team">
                <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column">
                  <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column__item">
                    <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.visiting_team + '.png'" />
                  </div>
                </div>
                <template v-for="(totalevents, index) in infoInactiveTime">
                  <div :key="index" class="te-teams__colscroll__wrapper__col__row-subheader__col-team__row-value">
                    {{ totalevents.visiting_team.time_lost_per_event_total }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="te-teams__colscroll__wrapper__col">
            <div class="te-teams__colscroll__wrapper__col__row-header">
              <div class="te-teams__colscroll__wrapper__col__row-header__item-logo">
                <img :src="'https://golstatsimages.blob.core.windows.net/todoelfut/' + tournament.tournament_id + '.png'" />
                {{ tournament.tournament_name }}
              </div>
            </div>
            <div class="te-teams__colscroll__wrapper__col__row-subheader">
              <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team">
                <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column">
                  <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column__item">
                    <img src="https://golstatsimages.blob.core.windows.net/todoelfut/104564A.png" />
                  </div>
                </div>
                <template v-for="(totalevents, index) in infoInactiveTime">
                  <div :key="index" class="te-teams__colscroll__wrapper__col__row-subheader__col-team__row-value">
                    {{ totalevents.season_inactive_time_average }}
                  </div>
                </template>
              </div>
              <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team">
                <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column">
                  <div class="te-teams__colscroll__wrapper__col__row-subheader__col-team__title-column__item">
                    <img src="https://golstatsimages.blob.core.windows.net/todoelfut/104565A.png" />
                  </div>
                </div>
                <template v-for="(totalevents, index) in infoInactiveTime">
                  <div :key="index" class="te-teams__colscroll__wrapper__col__row-subheader__col-team__row-value">
                    {{ totalevents.season_total_events_average }}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="cont-references">
      <div class="cont-references__green">
        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/time_average@2x2.png" />Por debajo del promedio de la liga
      </div>
      <div class="cont-references__red">
        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/time_average@2x.png" />Por encima del promedio de la liga
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableEventsTeams',
  components: {},
  computed: {},
  props: {
    infoInactiveTime: {
      type: Object,
      required: true,
    },
    teams: {
      type: Object,
      required: true,
    },
    tournament: {
      type: Object,
      required: true,
    },
    type: {
      type: Number,
      default: 1,
      required: true,
    },
  },

  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.color-gray {
  background-color: #f6f8fb !important;
}
.cont-references {
  width: 100%;
  height: 23px;
  display: inline-flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  @media screen and (max-width: 500px) {
    margin-top: 10px;
    justify-content: space-between;
  }
  &__green {
    width: 30%;
    height: 23px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    font-family: 'Avenir-Medium';
    font-stretch: normal;
    font-style: normal;
    line-height: 0.74;
    letter-spacing: normal;
    text-align: center;
    color: #132839;
    img {
      width: 12px;
      margin-right: 7px;
      @media screen and (max-width: 400px) {
        margin-right: 2px;
      }
    }
    @media screen and (max-width: 830px) {
      width: 40%;
    }
    @media screen and (max-width: 580px) {
      width: 45%;
    }
    @media screen and (max-width: 500px) {
      line-height: 0.94;
      width: 40%;
      padding-left: 5%;
    }
    @media screen and (max-width: 400px) {
      width: 45%;
      font-size: 10px;
    }
  }
  &__red {
    width: 30%;
    height: 23px;
    display: inline-flex;
    justify-content: center;
    font-family: 'Avenir-Medium';
    align-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.74;
    letter-spacing: normal;
    text-align: center;
    color: #132839;
    img {
      width: 12px;
      margin-right: 7px;
      @media screen and (max-width: 400px) {
        margin-right: 2px;
      }
    }
    @media screen and (max-width: 830px) {
      width: 40%;
    }
    @media screen and (max-width: 580px) {
      width: 50%;
    }
    @media screen and (max-width: 500px) {
      width: 40%;
      padding-right: 5%;
    }
    @media screen and (max-width: 400px) {
      width: 45%;
      font-size: 10px;
    }
  }
}
.te-teams {
  width: 100%;
  // height: auto;
  // background: palevioletred;
  display: inline-flex;
  justify-content: center;
  border-radius: 6px;
  border: solid 1px #b4c9dd;
  background-color: #fff;
  overflow: hidden;
  &__colstatic {
    width: 20%;
    border-right: 1px solid #b4c9dd;
    @media screen and (max-width: 830px) {
      width: 25%;
    }
    @media screen and (max-width: 740px) {
      width: 30%;
    }
    @media screen and (max-width: 540px) {
      width: 35%;
    }
    @media screen and (max-width: 440px) {
      width: 40%;
    }
    &__empty {
      width: 100%;
      height: 99px;
      background: white;
    }
    &__category-name {
      background: white;
      height: 28px;
      width: 100%;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      line-height: 28px;
      color: #132839;
      font-family: 'Avenir-Demi';
      padding-left: 5%;
      @media screen and (max-width: 830px) {
        text-align: right;
        padding-left: 0%;
        padding-right: 3%;
      }
      @media screen and (max-width: 400px) {
        font-size: 11px;
      }
      @media screen and (max-width: 365px) {
        font-size: 9px;
      }
    }
    &__category-name:nth-child(even) {
      background-color: #f6f8fb !important;
    }
  }
  &__colscroll {
    width: 80%;
    height: auto;
    overflow-x: auto;
    overflow-y: hidden;
    // background: peru;
    @media screen and (max-width: 830px) {
      width: 75%;
    }
    @media screen and (max-width: 740px) {
      width: 70%;
    }
    @media screen and (max-width: 540px) {
      width: 65%;
    }
    @media screen and (max-width: 440px) {
      width: 60%;
    }
    &__wrapper {
      width: 100%;
      height: auto;
      @media screen and (max-width: 830px) {
        width: 763px;
      }
      @media screen and (max-width: 400px) {
        width: 720px;
      }
      @media screen and (max-width: 360px) {
        width: 580px;
      }
      display: inline-flex;
      justify-content: left;
      align-content: center;
      align-items: center;
      &__col {
        width: 25%;
        height: auto;
        border-right: 1px solid #b4c9dd;
        &__row-header {
          width: 100%;
          height: 50px;
          background: white;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          border-bottom: 1px solid #b4c9dd;
          margin-bottom: 1px;
          &__item-logo {
            display: inline-flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            width: 88%;
            height: auto;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            // line-height: 50px;
            letter-spacing: normal;
            text-align: center;
            color: #132839;
            font-family: 'Avenir-Demi';
            img {
              margin-right: 7px;
              width: 28px;
            }
          }
          &__item {
            width: 88%;
            height: auto;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.9;
            letter-spacing: normal;
            text-align: center;
            color: #132839;
            font-family: 'Avenir-Demi';
            &__text {
              font-family: 'Avenir-Regular';
            }
            @media screen and (max-width: 1030px) {
              width: 100%;
            }
            @media screen and (max-width: 930px) {
              font-size: 11px;
            }
          }
        }
        &__row-subheader {
          width: 100%;
          height: auto;
          display: inline-flex;
          justify-content: space-between;
          align-content: center;
          align-items: center;
          &__col-team {
            width: 50%;
            background: brown;
            border-right: 1px solid #b4c9dd;
            &__row-value {
              width: 100%;
              height: 28px;
              display: inline-flex;
              justify-content: center;
              align-content: center;
              align-items: center;
              font-size: 13px;
              background: white;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 28px;
              letter-spacing: normal;
              text-align: center;
              color: #132839;
              font-family: 'Avenir-Demi';
              img {
                width: 10px;
                margin-right: 5px;
              }
            }
            &__row-value:nth-child(even) {
              background-color: #f6f8fb !important;
            }
            &__title-column {
              width: 100%;
              height: 49px;
              background: white;
              display: inline-flex;
              justify-content: center;
              align-content: center;
              align-items: center;
              &__item {
                width: 40px;
                height: 40px;
                border-radius: 12px;
                background-color: rgba(232, 236, 239, 0.3);
                display: inline-flex;
                justify-content: center;
                align-content: center;
                align-items: center;
                img {
                  width: 30px;
                }
              }
            }
          }
          &__col-team:last-child {
            border-right: 0px solid #b4c9dd;
          }
        }
      }
      &__col:last-child {
        border-right: 0px solid #b4c9dd;
      }
    }
  }
}
</style>
